export const IPOOTPLEADS_DATA = "IPOMASTERBANK_DATA";
export const IPOOTPLEADS_ERROR_DATA = "IPOMASTERBANK_ERROR_DATA";
export const IPOOTPLEADS_HIDE_ERROR_DATA = "IPOMASTERBANK_HIDE_ERROR_DATA";
export const IPOOTPLEADS_START_LOADER = "IPOMASTERBANK_START_LOADER";
export const IPOOTPLEADS_STOP_LOADER = "IPOMASTERBANK_STOP_LOADER";
